import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const statusObject = z.object({
  status: z.string(),
});

const responseSchema = z.object({
  amazon: statusObject,
  amazon_mws: statusObject,
  google: statusObject,
  "wm-mp": statusObject,
  "wm-advertising": statusObject,
  shopify: statusObject.extend({
    shops: z.string().array(),
  }),
});

export const appsApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getAppsStatus",
    method: "get",
    path: "/apps/status",
    status: 200,
    response: responseSchema,
  }).build(),
);
